<template>
  <div class="carousel-container">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="30"
      :loop="true"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false,
      }"
      :pagination="{ clickable: true }"
      :navigation="true"
    >
      <swiper-slide v-for="(slide, index) in slides" :key="index">
        <a :href="slide.link" target="_blank" class="slide-link">
          <picture>
            <!-- Imagem para mobile (até 768px) -->
            <source 
              media="(max-width: 768px)" 
              :srcset="slide.imageMobile" 
            />
            <!-- Imagem para desktop (acima de 768px) -->
            <source 
              media="(min-width: 769px)" 
              :srcset="slide.imageDesktop" 
            />
            <!-- Fallback -->
            <img 
              :src="slide.imageDesktop" 
              :alt="slide.title" 
              class="slide-image" 
            />
          </picture>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const modules = [Navigation, Pagination, Autoplay];

const slides = ref([

  {
    imageMobile: '/assets/img/carrossel/novo_app.jpg',
    imageDesktop: '/assets/img/carrossel/novo_app.jpg',
    link: '#'
  },
  {
    imageMobile: '/assets/img/carrossel/disney_lancamento.jpg',
    imageDesktop: '/assets/img/carrossel/disney_lancamento.jpg',
    link: '#'
  },
  {
    imageMobile: '/assets/img/carrossel/sva_02.jpg',
    imageDesktop: '/assets/img/carrossel/sva_02.jpg',
    link: '#'
  },
  {
    imageMobile: '/assets/img/carrossel/banner_5.jpg',
    imageDesktop: '/assets/img/carrossel/banner_5.jpg',
    link: '#'
  },
  {
    imageMobile: '/assets/img/carrossel/06.jpg',
    imageDesktop: '/assets/img/carrossel/06.jpg',
    link: '#'
  },
]);
</script>

<style scoped>
.carousel-container {
  width: 100%;
  /* max-width: 1200px; */
  margin: 0 auto;
  /* padding: 20px; */
}

.slide-link {
  display: block;
  position: relative;
  text-decoration: none;
  color: inherit;
}

.slide-image {
  width: 100%;
  height: auto;
  min-height: 400px;
  object-fit: cover;
  border-radius: 10px;
}

/* Ajuste de altura para mobile */
@media (max-width: 768px) {
  .slide-image {
    min-height: 500px;
  }
}

.slide-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: white;
  padding: 20px;
  border-radius: 0 0 10px 10px;
}

.slide-caption h3 {
  margin: 0 0 5px 0;
  font-size: 24px;
}

.slide-caption p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

.swiper-button-next::after,
.swiper-button-next {
  font-size:12px important; 
}

:deep(.swiper-button-next),
:deep(.swiper-button-prev) {
  color: white;
  background: none;
  padding: 15px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px important;
}

:deep(.swiper-pagination-bullet-active) {
  background: #4ECDC4;
}
</style>